import { ColorOptions, Icon, ModBox, SpacerNew, Text } from '@jfs/ui-new'
import { ButtonNew } from '../../../components/AdminButton'
import { FC } from 'react'

interface FiuStatusProps {
  isCheckerApproved: boolean
  data: any
  onSubmit: any
}

const Footer = ({ onSubmit }: any) => {
  return <ButtonNew onPress={onSubmit} title={'Go to My Queue'} height={40} width={180} color={'PRIMARY'} />
}

const FiuStatus: FC<FiuStatusProps> = ({ isCheckerApproved, data, onSubmit }: FiuStatusProps) => {
  console.log('FiuStatus data', JSON.parse(JSON.stringify(data)), isCheckerApproved)

  return (
    <>
      <ModBox width={'100%'} height={'100%'} alignItems={'center'} justifyContent={'center'} alignSelf={'center'}>
        <ModBox
          w={64}
          h={64}
          borderRadius={32}
          marginBottom={32}
          backgroundColor={'#FBEDD6' as ColorOptions}
          alignItems={'center'}
          justifyContent={'center'}>
          <Icon
            id={isCheckerApproved ? 'STATUS_AWAITING' : 'SUCCESSFUL_FILLED'}
            color={isCheckerApproved ? ('#E68E00' as ColorOptions) : 'RED'}
            size={32}
          />
        </ModBox>

        <Text
          title={isCheckerApproved ? 'Application Approved - Creation in Progress' : 'Application Rejected'}
          color={'BLACK_21'}
          fontSize={16}
          fontFamily={'jiotype-bold'}
          textAlign={'center'}
        />
        <SpacerNew size={24} direction="vertical" />
        <Text title={'Application ID'} color={'BLACK_75'} fontSize={12} fontFamily={'jiotype-medium'} />
        <Text title={data?.data?.applicationId} color={'BLACK_21'} fontSize={12} fontFamily={'jiotype-bold'} />
        <SpacerNew size={64} direction="vertical" />
        <Footer onSubmit={onSubmit} />
      </ModBox>
    </>
  )
}

export default FiuStatus
